import { flexRender } from '@tanstack/react-table';
import {
  Flex,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
} from '@tonic-one/react';
import { useTranslation } from 'react-i18next';

export const AdvancedTooltipPopover = ({
  cell,
  advanceProtectionInfo,
}: {
  cell: any;
  advanceProtectionInfo: any;
}) => {
  const { t } = useTranslation();

  return (
    <Popover trigger="hover">
      <PopoverTrigger>
        <Flex>{flexRender(cell.column.columnDef.cell, cell.getContext())}</Flex>
      </PopoverTrigger>
      <PopoverContent maxWidth="384px">
        <PopoverHeader>
          {t('dashboard.serviceStatus.advancedTooltip.title')}
        </PopoverHeader>
        <PopoverBody>
          <Flex>{t('dashboard.serviceStatus.advancedTooltip.preDesc')}</Flex>
          <AdvancedTooltipStringList
            list={advanceProtectionInfo.advancedProtectionServiceList}
          ></AdvancedTooltipStringList>
          <Flex>
            {t('dashboard.serviceStatus.advancedTooltip.creditDesc', {
              NUMBER: advanceProtectionInfo.creditsPerDefaultNumber,
            })}
          </Flex>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

export const AdvancedTooltipStringList = ({ list }: { list: string[] }) => (
  <ul style={{ marginTop: '4px', marginBottom: '4px', paddingLeft: '16px' }}>
    {list.map((item, index) => (
      <li key={index}>{item}</li>
    ))}
  </ul>
);

export const advancedStyle = {
  left: '0.2em',
  fontFamily:
    'Segoe UI, -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica, Arial, sans-serif',
  fontStyle: 'italic',
  backgroundImage: 'linear-gradient(89.91deg, #10B4D3 0%, #41E9C5 100%)',
  WebkitBackgroundClip: 'text',
  color: 'transparent',
  lineHeight: '12px',
  fontSize: '10px',
  fontWeight: '400',
};
